export const APPLICATIONS_UI_ACTION_NAMES = {
  SHOW_CREATE_APPLICATION_MODAL:
    'APPLICATIONS_UI_ACTION_NAMES-SHOW_CREATE_APPLICATION_MODAL',
  HIDE_CREATE_APPLICATION_MODAL:
    'APPLICATIONS_UI_ACTION_NAMES-HIDE_CREATE_APPLICATION_MODAL',
};

export const showCreateApplicationModal = () => ({
  type: APPLICATIONS_UI_ACTION_NAMES.SHOW_CREATE_APPLICATION_MODAL,
  payload: undefined,
});

export const hideCreateApplicationModal = () => ({
  type: APPLICATIONS_UI_ACTION_NAMES.HIDE_CREATE_APPLICATION_MODAL,
  payload: undefined,
});
